var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { attrs: { href: _vm.url, title: _vm.name } },
    [
      _c("base-image", {
        staticClass: "_rounded--common _bxsh--base",
        attrs: {
          src: _vm.imageUrl,
          width: _vm.size,
          height: _vm.size,
          alt: _vm.name,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }